import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

// Legacy hash URLs (`/#/?id=&jwt=` from the SSO callback, old `/#/map`
// bookmarks): the router is clean-URL and never reads the fragment, so move it
// into the path before bootstrap or the SSO params are lost and login loops.
if (window.location.hash.startsWith("#/")) {
  window.history.replaceState(null, "", window.location.hash.slice(1));
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
